import axios from "axios";
import { GetAllGGNotificationGraspDTO, GetAllGGNotificationGraspFiltersDTO, GGNotificationGraspDTO } from "./dto";
import { GGNotificationGraspService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";

export class GGNotificationGraspServiceImpl implements GGNotificationGraspService {

    public UpdateGGNotificationGrasp(data: GGNotificationGraspDTO, id: string): Promise<void> {
        return axios.put("/api/gg-notification-grasp/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllGGNotificationGrasp(filters: GetAllGGNotificationGraspFiltersDTO): Promise<GetAllGGNotificationGraspDTO> {
        return axios.get("/api/gg-notification-grasp", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                ggNotificationId: filters.ggNotificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetGGNotificationGraspById(id: string): Promise<GGNotificationGraspDTO> {
        return axios.get("/api/gg-notification-grasp/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}